import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

export default function StoryCard({ story, index = 0, owner, onDelete }) {
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardActionArea
        component={Link}
        to={`/story/${story.id}`}
        sx={{ flexGrow: 1, display: "block" }}
      >
        <div className={`book-cover tone-${index % 3}`}>
          <span className="cover-label">A world worth getting lost in.</span>
        </div>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="overline" sx={{ fontSize: 9 }}>
            An interactive story
          </Typography>
          <Typography variant="h6" component="h2" mt={0.5} mb={1}>
            {story.story_name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, minHeight: 44, overflowWrap: "anywhere" }}
          >
            {story.story_desc ||
              "A new adventure is waiting. Where will your choices take you?"}
          </Typography>
          <Box display="flex" justifyContent="space-between" gap={2}>
            <Typography variant="caption" color="text.secondary">
              by {story.author}
            </Typography>
            <Typography
              variant="caption"
              display="flex"
              alignItems="center"
              gap={0.5}
            >
              <FavoriteBorderIcon sx={{ fontSize: 14 }} />
              {story.number_of_likes || 0}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
      {owner && (
        <CardActions sx={{ px: 3, pb: 2, justifyContent: "space-between" }}>
          <Button
            component={Link}
            to={`/edit/${story.id}`}
            size="small"
            variant="outlined"
          >
            Edit story
          </Button>
          {onDelete && (
            <Button
              color="error"
              size="small"
              onClick={() => onDelete(story.id)}
            >
              Delete
            </Button>
          )}
        </CardActions>
      )}
    </Card>
  );
}
